var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,10c-5.5,0-10.8,1.1-15.7,3.2c-4.7,2-9,4.9-12.7,8.6c-3.7,3.7-6.6,8-8.6,12.7C11,39.2,10,44.5,10,50h7.5c0-4.4,0.9-8.7,2.6-12.6c1.6-3.8,4-7.2,6.9-10.2c2.9-2.9,6.4-5.3,10.2-6.9c3.9-1.7,8.1-2.6,12.6-2.6c4.4,0,8.7,0.9,12.6,2.6c3.8,1.6,7.2,4,10.2,6.9c2.9,2.9,5.3,6.4,6.9,10.2c1.7,3.9,2.6,8.1,2.6,12.6c0,4.4-0.9,8.7-2.6,12.6c-1.6,3.8-4,7.2-6.9,10.2c-2.9,2.9-6.4,5.3-10.2,6.9c-3.9,1.7-8.1,2.6-12.6,2.6v7.5c5.5,0,10.8-1.1,15.7-3.2c4.7-2,9-4.9,12.7-8.6c3.7-3.7,6.6-8,8.6-12.7C88.9,60.8,90,55.5,90,50c0-5.5-1.1-10.8-3.2-15.7c-2-4.7-4.9-9-8.6-12.7c-3.7-3.7-8-6.6-12.7-8.6C60.8,11.1,55.5,10,50,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,50l-7.5,0l10,15l10-15h-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,50l7.5,0l-10-15l-10,15h7.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.404bef7957efac7dd498d7bc43aa661e.svg";
export { ForwardRef as ReactComponent };